/**
 *  @file FMSService.ts
 *  @author  Kenny Lopez
 *  @version 1.0
 *  @description This is a util class for comunicate with FMS service.
 */
import AppConfig from "@/config/AppConfig";
import axios from "axios";

export default class FMSService {
  /**
   * Upload file to fms.
   *
   * @param data  image bytes
   *
   */
  static upload(imageBuffer, imageName) {
    const baseUrlFileServer = AppConfig.baseUrlFileServer;
    let formData = new FormData();
    formData.append("file", imageBuffer, imageName);

    return axios
      .post(baseUrlFileServer, formData, {
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        return response.data;
      });
  }

  static getHeaders(form) {
    return new Promise((resolve, reject) => {
      form.getLength((err, length) => {
        if (err) {
          reject(err);
        }
        let headers = Object.assign({
            "Content-Length": length
          },
          form.getHeaders()
        );
        resolve(headers);
      });
    });
  }
}